import * as Sentry from '@sentry/react';

export const SentryFallbackRender: Sentry.FallbackRender = (errorData) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: '16px',
        textAlign: 'center',
      }}
    >
      <h1>Aplikace zaznamenala nečekaný pád</h1>
      <h3>Omlouváme se za nepříjemnosti. Vývojáři byli o tomto incidentu informováni.</h3>
      <pre style={{ whiteSpace: 'break-spaces' }}>Error: {errorData.error.toString()}</pre>
      <button
        onClick={() => {
          errorData.resetError();
          window.location.href = '/';
        }}
      >
        Zkusit znovu
      </button>
    </div>
  );
};
